export default "__VITE_ASSET__vYY6FKjZ__"